import React from 'react';
export function Footer() {
  return <footer className="bg-navy text-cream/60 py-12 px-6 text-center" data-id="element-47">
      <div className="max-w-4xl mx-auto" data-id="element-48">
        <p className="text-lg" data-id="element-49">
          © {new Date().getFullYear()} Checklist Vital. Todos los derechos
          reservados.
        </p>
        <p className="text-sm mt-3 text-cream/40" data-id="element-50">
          Siempre consulta con un especialista de la salud antes de tomar algún
          medicamento.
        </p>
      </div>
    </footer>;
}